import { Card } from "@mantine/core";

import { Content, Footer, Header, Submit } from "./components";
import { Col } from "./components/Col";
import { Grid } from "./components/Grid";
import classes from "./styles/PlansCard.module.css";

import type { PlanName } from "@/types/plans";
import type { FC, ReactNode } from "react";

export type PlansCardWrapperProps = {
  children: ReactNode;
  selectedPlan: PlanName | null;
  selectedCard: string;
  w?: string;
  maw?: string;
  h?: string | number;
  onClick?: () => void;
};

const PlansCard: FC<PlansCardWrapperProps> = ({
  children,
  w,
  maw,
  h = "33em",
  onClick,
  selectedCard,
  selectedPlan,
}) => {
  return (
    <Card
      withBorder
      w={w}
      maw={maw}
      h={h}
      aria-label={selectedCard}
      onClick={onClick}
      className={selectedPlan === selectedCard ? classes.selectedCard : classes.planCard}
      mih="fit-content"
      style={{
        display: "grid",
        gridTemplateRows: `5em 1fr 5em`,
        gap: "0.5rem",
      }}
    >
      {children}
    </Card>
  );
};

export default Object.assign(PlansCard, {
  Header,
  Content,
  Footer,
  Submit,
  Grid: Grid,
  Col: Col,
});
